import { useNavigate } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { LoadingButton } from '@mui/lab'
import { Box, useMediaQuery } from '@mui/material'
import { routes } from '@/router'
import { sessionButtonSx } from '../session-button'
import {
  RedirectIfAuthenticated,
  SessionField,
  SessionScreen,
} from '../session-screen'
import { useSignupDraft } from './use-signup-draft'
import { NameFormData, nameFormSchema } from './signup.schema'
import { flowProgress } from '../profile/profile-steps'

export function SignupNamePage() {
  const navigate = useNavigate()
  const isDesktop = useMediaQuery('(min-width:900px)', { noSsr: true })
  const { draft, setFullName } = useSignupDraft()

  const { handleSubmit, control, watch } = useForm<NameFormData>({
    resolver: zodResolver(nameFormSchema),
    defaultValues: { fullName: draft.fullName },
    mode: 'onChange',
  })

  const fullName = watch('fullName')
  const isValid = nameFormSchema.safeParse({ fullName }).success

  return (
    <RedirectIfAuthenticated>
      <Box
        component="form"
        onSubmit={handleSubmit(({ fullName: name }) => {
          setFullName(name.trim())
          navigate(routes.session.signup.cpf)
        })}
        sx={{ display: 'flex', flex: 1 }}
      >
        <SessionScreen
          title="Digite seu nome"
          subtitle="Como você se chama?"
          progress={flowProgress('name', null)}
          onBack={() =>
            navigate(isDesktop ? routes.session.signin : routes.session.welcome)
          }
          footer={
            <LoadingButton
              type="submit"
              size="large"
              fullWidth
              disabled={!isValid}
              sx={sessionButtonSx()}
            >
              Continuar
            </LoadingButton>
          }
        >
          <Controller
            name="fullName"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <SessionField
                {...field}
                id="signup-name"
                autoComplete="name"
                placeholder="Nome completo"
                errorText={field.value.trim() ? error?.message : undefined}
                autoFocus
              />
            )}
          />
        </SessionScreen>
      </Box>
    </RedirectIfAuthenticated>
  )
}
